import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const styles = xcss({
	height: '88px',
});

export const EmptyFooter = (): React.JSX.Element => {
	return <Box xcss={styles} />;
};
